// Module
var code = "<script>let $ctrl</script> <molecule-panel-view> <transclude-content> <div class=\"welcome-heading\"> <h2 translate=\"TR_021024-3e86e4_TR\"></h2> <br> <span translate=\"TR_021024-ff5411_TR\"></span> </div> </transclude-content> </molecule-panel-view> ";
// Exports
module.exports = code;